
import { MapLocation } from '@/types/location';

// Black Ball Center Locations
export const blackBallCenters: MapLocation[] = [
  {
    id: 53001,
    name: "Black Ball - Riyadh (Al Nahda)",
    type: "Game Center",
    devices: 4,
    coordinates: [24.771510945538427, 46.81422472024109],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
